import { GameTemplate, GameState, InningsState } from '../types/game';

export const DEFAULT_TEAM_A_PLAYERS = [
  "Player 1", "Player 2", "Player 3", "Player 4", "Player 5",
  "Player 6", "Player 7", "Player 8", "Player 9", "Player 10", "Player 11"
];

export const DEFAULT_TEAM_B_PLAYERS = [
  "Bowler 1", "Bowler 2", "Bowler 3", "Bowler 4", "Bowler 5",
  "Bowler 6", "Bowler 7", "Bowler 8", "Bowler 9", "Bowler 10", "Bowler 11"
];

export const DEFAULT_MATCH_SETTINGS = {
  oversPerInnings: 20,
  numberOfPlayers: 11,
  ballsPerOver: 6,
  customRules: {
    enableRetirement: false,
    retirementRuns: 25,
    enableMaxBallsPerOver: false,
    maxBallsPerOver: 9,
    lastOverExemption: true,
    enableLastManStands: false,
  },
};

// Animation variants
export const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 24,
    }
  }
};

export const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2,
    }
  }
};

export const buttonTap = {
  scale: 0.95,
  transition: { duration: 0.1 }
};

export const buttonHover = {
  scale: 1.02,
  transition: { 
    type: "spring", 
    stiffness: 400, 
    damping: 17 
  }
};

export const createInitialInningsState = (battingTeamPlayers: string[], bowlingTeamPlayers: string[]): InningsState => ({
  runs: 0,
  wicketsDown: 0,
  ballsThisOver: 0,
  totalBalls: 0,
  currentOver: 1,
  currentOverBalls: [],
  previousOvers: [],
  batter1: {
    name: battingTeamPlayers[0] || "Batter 1",
    runs: 0,
    balls: 0,
    onStrike: true,
    isRetired: false,
  },
  batter2: {
    name: battingTeamPlayers[1] || "Batter 2",
    runs: 0,
    balls: 0,
    onStrike: false,
    isRetired: false,
  },
  bowler: { 
    name: bowlingTeamPlayers[0] || "Bowler 1", 
    runsConceded: 0, 
    ballsBowled: 0,
    wicketsTaken: 0
  },
  wicketRecords: [],
  isLastManStands: false,
});

export const createInitialGameState = (template?: GameTemplate): GameState => {
  return {
    teamA: "Team A",
    teamB: "Team B",
    teamAPlayers: [...DEFAULT_TEAM_A_PLAYERS],
    teamBPlayers: [...DEFAULT_TEAM_B_PLAYERS],
    matchSettings: template ? {
      oversPerInnings: template.oversPerInnings,
      numberOfPlayers: template.numberOfPlayers,
      ballsPerOver: template.ballsPerOver,
      customRules: template.customRules,
    } : { ...DEFAULT_MATCH_SETTINGS },
    currentInnings: 1,
    battingTeam: 'A',
    bowlingTeam: 'B',
    innings1: createInitialInningsState(DEFAULT_TEAM_A_PLAYERS, DEFAULT_TEAM_B_PLAYERS),
    innings2: null,
    gameComplete: false,
    winner: undefined,
    currentTemplate: template ? {
      name: template.name,
      id: template.id,
    } : undefined,
  };
};

export const getGameFormatName = (oversPerInnings: number): string => {
  switch (oversPerInnings) {
    case 5:
      return "5 Over";
    case 8:
      return "8 Over";
    case 10:
      return "10 Over";
    case 20:
      return "T20";
    case 50:
      return "ODI";
    case 90:
      return "Test";
    default:
      if (oversPerInnings >= 80) {
        return "Test";
      } else if (oversPerInnings >= 40) {
        return "ODI";
      } else if (oversPerInnings >= 15) {
        return "T20";
      } else {
        return `${oversPerInnings} Over`;
      }
  }
};

export const getGameTitle = (gameState: GameState): string => {
  if (gameState.currentTemplate) {
    return gameState.currentTemplate.name;
  }
  
  return getGameFormatName(gameState.matchSettings.oversPerInnings);
};